const ResponsiveAlert = () => {
  return <div></div>;
};

export default ResponsiveAlert;
